/**
 * Isolates map failures (Google Maps auth/runtime errors) so a broken map
 * never takes the whole page down — the rest of the app stays usable.
 */

import { Component, type ReactNode } from "react";

export class MapErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        this.props.fallback ?? (
          <div className="flex h-full w-full items-center justify-center bg-cream/60 p-6">
            <div className="max-w-sm rounded-2xl bg-background/95 p-5 text-center shadow-float">
              <div className="text-sm font-bold text-brown-dark">Map unavailable</div>
              <p className="mt-1 text-xs leading-snug text-muted-foreground">
                You can still search listings and open details — only the map view is affected.
              </p>
              <button
                type="button"
                onClick={() => this.setState({ failed: false })}
                className="mt-4 inline-flex items-center justify-center rounded-full bg-brown-dark px-4 py-2 text-xs font-semibold text-cream"
              >
                Retry loading map
              </button>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
